import Carousel from 'react-bootstrap/Carousel';

import 'css/src/components/public-pages/common-sections/CompanyInfoSection';

import React, { useState } from 'react';

import IconCircle from 'js/src/components/common/ui/IconCircle';

type Props = {
    backgroundUrl?: string;
    logoUrl?: string;
    description?: string;
    customerName?: string;
    customerDesignation?: string;
    storyUrl?: string;
};

const CarouselItem = React.memo(function CarouselItem({
    backgroundUrl,
    logoUrl,
    description,
    customerName,
    customerDesignation,
    storyUrl,
}: Props) {
    return (
        <div className="row justify-content-center">
            <div className="col-sm-10 col-md-12">
                <div className="use-case-container">
                    <div className="use-case-background-container">
                        <img
                            src={backgroundUrl}
                            className="use-case-background"
                            loading="lazy"
                            decoding="async"
                            alt="Customer case study background"
                        />
                    </div>
                    <div className="row">
                        <div className="col-sm-12 d-flex justify-content-start">
                            <div className="d-flex flex-column content-container mx-l5-16 my-l5-16 mb-l5-8 p-l5-16 rounded case-study-text-container">
                                <div className="my-l5-8 py-l5-16 px-l5-16">
                                    <img
                                        loading="lazy"
                                        src={logoUrl}
                                        className="carousel-logo"
                                        decoding="async"
                                        alt="Company logo"
                                    />
                                </div>

                                <div className="my-l5-4 px-l5-16 case-study-text">
                                    <p className="font-l5 font-l5--regular my-l5-16">
                                        {description}
                                    </p>
                                </div>

                                <div className="my-l5-4 px-l5-16 case-study-text">
                                    <span>
                                        <strong>{customerName}</strong>
                                    </span>
                                    <br />
                                    <span>{customerDesignation}</span>
                                </div>

                                <div className="my-l5-16 px-l5-16">
                                    <hr />
                                    <a
                                        href={storyUrl}
                                        className="font-l5 font-l5--regular text-primary"
                                    >
                                        Read case study &rarr;
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

const CompanyInfoSection = React.memo(function CompanyInfoSection() {
    const caseStudiesData = [
        {
            backgroundUrl:
                'https://images.lumen5.com/2025-website-assets/landing/carousel/carousel-siemens-bg.webp',
            logoUrl: 'https://images.lumen5.com/2025-website-assets/logos/color/Siemens.webp',
            description:
                '“With the traditional agency, the time is usually about one week. But with Lumen5, it’s cut down from weeks to hours.”',
            customerName: 'Michelle Hsiao',
            customerDesignation: 'Visual content director at Siemens AG',
            storyUrl: 'https://content.lumen5.com/siemens',
        },
        {
            backgroundUrl:
                'https://images.lumen5.com/2025-website-assets/landing/carousel/carousel-dnv-bg.webp',
            logoUrl: 'https://images.lumen5.com/2025-website-assets/logos/color/DNV.webp',
            description:
                "“Lumen5 is especially helpful for business people who don't have the technical experience to make their own videos.”",
            customerName: 'Peter Lovegrove',
            customerDesignation: 'Media relations and content manager',
            storyUrl: 'https://content.lumen5.com/dnv', // defined in contentful
        },
        {
            backgroundUrl:
                'https://images.lumen5.com/2025-website-assets/landing/carousel/carousel-mhi-bg.webp',
            logoUrl: 'https://images.lumen5.com/2025-website-assets/logos/color/Mitsubishi.webp',
            description:
                '“Thanks to Lumen5, we have been able to cut down on the time and costs related to video making.”',
            customerName: 'Adrian Ngo',
            customerDesignation: 'Global advertising and sponsorships',
            storyUrl: 'https://content.lumen5.com/mitsubishi', // defined in contentful
        },
        {
            backgroundUrl:
                'https://images.lumen5.com/2025-website-assets/landing/carousel/cisco_bg_2.webp',
            logoUrl: 'https://images.lumen5.com/2025-website-assets/logos/black/Cisco.webp',
            description:
                '“We’re able to create a video quickly with a turnaround of five minutes versus trying to coordinate with an agency and see if they have time to fit you in. With Lumen5, you could just get it right then and there.”',
            customerName: 'Eric Chu',
            customerDesignation: 'Social & digital content manager',
            storyUrl: 'https://content.lumen5.com/cisco', // defined in contentful
        },
        {
            backgroundUrl:
                'https://images.lumen5.com/2025-website-assets/landing/carousel/carousel-cms-bg.webp',
            logoUrl: 'https://images.lumen5.com/2025-website-assets/logos/color/v2/cms.webp',
            description:
                "“The best part about Lumen5 is that it's not time-consuming. It's really easy and you only need a couple of minutes to create a video because everything is included.”",
            customerName: 'Amsal Alihodzic',
            customerDesignation: 'Senior online marketing manager',
            storyUrl: 'https://content.lumen5.com/cms', // defined in contentful
        },
        {
            backgroundUrl:
                'https://images.lumen5.com/2025-website-assets/landing/carousel/emerson_bg.webp',
            logoUrl: 'https://images.lumen5.com/2025-website-assets/logos/black/Emerson_Black.webp',
            description:
                "“We have scaled Lumen5's use across our marketing organization, realizing benefits across many team layers. As company communicators, this agile tool enhances each customer's experience and engagement.”",
            customerName: 'Michelle Montes',
            customerDesignation: 'Director of global integrated marketing, Emerson',
            storyUrl: 'https://content.lumen5.com/emerson', // defined in contentful
        },
        {
            backgroundUrl:
                'https://images.lumen5.com/2025-website-assets/landing/carousel/about-swiss.webp',
            logoUrl: 'https://images.lumen5.com/2025-website-assets/logos/black/Swiss%20Re.webp',
            description:
                '“We saw increasing demand within Communications for an intuitive self-service video production tool and Lumen5 filled the gap.”',
            customerName: 'Annie Wu',
            customerDesignation: 'Creative & digital assets manager, Corporate Voice, Swiss Re',
            storyUrl: 'https://content.lumen5.com/swissre', // defined in contentful
        },
    ];

    const [carouselIndex, setCarouselIndex] = useState(0);

    const handleCarouselSelect = (selectedIndex: number) => {
        setCarouselIndex(selectedIndex);
    };

    const navigateToCarouselIndex = (index: number) => {
        setCarouselIndex(index);
    };

    return (
        <div className="row justify-content-center align-items-center my-l5-24 company-info-section">
            <div className="col-sm-12">
                <div className="d-flex my-l5-16 justify-content-center flex-column">
                    <div className="carousel-l5">
                        <Carousel
                            activeIndex={carouselIndex}
                            onSelect={handleCarouselSelect}
                            interval={null}
                            indicators={false}
                            prevIcon={
                                <IconCircle
                                    materialIconName="navigate_before"
                                    backgroundColor="white"
                                    className="shadow"
                                />
                            }
                            nextIcon={
                                <IconCircle
                                    materialIconName="navigate_next"
                                    backgroundColor="white"
                                    className="shadow"
                                />
                            }
                        >
                            {caseStudiesData.map((caseStudyData, index) => {
                                return (
                                    <Carousel.Item key={index}>
                                        <CarouselItem
                                            backgroundUrl={caseStudyData.backgroundUrl}
                                            logoUrl={caseStudyData.logoUrl}
                                            description={caseStudyData.description}
                                            customerName={caseStudyData.customerName}
                                            customerDesignation={caseStudyData.customerDesignation}
                                            storyUrl={caseStudyData.storyUrl}
                                        />
                                    </Carousel.Item>
                                );
                            })}
                        </Carousel>
                    </div>

                    <div className="d-flex justify-content-center mx-l5-md-48 px-l5-md-48 my-l5-16">
                        {caseStudiesData.map((caseStudyData, index) => {
                            return (
                                <div key={index} className="d-flex align-items-center">
                                    <img
                                        loading="lazy"
                                        className="business-logos carousel-thumb mx-l5-16 my-l5-0 cursor-pointer"
                                        src={caseStudyData.logoUrl}
                                        onClick={() => navigateToCarouselIndex(index)}
                                        decoding="async"
                                        alt="Company logo thumbnail"
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
});

export default CompanyInfoSection;
